import { createSlice, createAsyncThunk, PayloadAction, ActionReducerMapBuilder } from "@reduxjs/toolkit";
import axios from "axios";
import { config } from "../../../utils/config";

const { apiEndpoint } = config;
interface CoreState {
    loading?: boolean,
    data?: any,
    error?: any
};

const initialState: CoreState = {
    loading: false,
    data: '',
    error: ''
}

export const checkLogin = createAsyncThunk('login/checkLogin', async (cred: any, { rejectWithValue }) => {
    try {
        const { data } = await axios({

            url: `${apiEndpoint}/login`,

            method: "POST",
            data: cred
        });
        const { token, status } = data;
        if (status === 200) {
            sessionStorage.setItem("us_st_d", token)
            return token;
        }

        return rejectWithValue({
            status,
            message: data?.message || "Unable to log in at the moment. Please try again.",
            errors: data?.errors,
        });
    } catch (error: any) {
        const responseData = error?.response?.data;
        return rejectWithValue({
            status: error?.response?.status || responseData?.status || 500,
            message: responseData?.message || "Unable to log in at the moment. Please try again.",
            errors: responseData?.errors,
        });
    }
})

const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(checkLogin.pending, (state, action) => {
            state.loading = true;
            state.data = '';
            state.error = '';

        })
        builder.addCase(checkLogin.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = '';
        })
        builder.addCase(checkLogin.rejected, (state, action) => {
            state.loading = false;
            state.data = '';
            state.error = action.payload || { message: action.error.message };
        })
    }
})


export default loginSlice.reducer;